
import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Check localStorage for saved theme, default to 'Teal'
    const savedTheme = localStorage.getItem('app-theme');

    const themes = [
        ////Light Theme and text black////
        {
            name: 'Teal (Default)',
            color: '#9e9e9e',
            textColor: '#000000',
            gradient: 'from-[#FFFFFF]',
            cssGradient: '#FFFFFF'
        },
        {
            name: 'Ayurvedic',
            color: '#557A46',
            textColor: '#000000',
            bgColor: '#F4F2E6',
            gradient: 'from-[#F4F2E6]',
            cssGradient: '#F4F2E6'
        },
        {
            name: 'Blue',
            color: '#459B7A',
            textColor: '#000000',
            gradient: 'from-[#EBF5FB] to-[#2980B9]',
            cssGradient: 'linear-gradient(to right, #EBF5FB, #459B7A)'
        },
        ////Dark Theme and text white////
        {
            name: 'Purple',
            color: '#1e293b',
            textColor: '#FFFFFF',
            gradient: 'from-[#0f172a]',
            cssGradient: '#0f172a'
        },
        /*
        {
            name: 'Orange',
            color: '#D35400',
            textColor: '#000000',
            gradient: 'from-[#FDF2E9] to-[#D35400]',
            cssGradient: 'linear-gradient(to right, #FDF2E9, #D35400)'
        },
        {
            name: 'Green',
            color: '#27AE60',
            textColor: '#000000',
            gradient: 'from-[#E8F8F5] to-[#27AE60]',
            cssGradient: 'linear-gradient(to right, #E8F8F5, #27AE60)'
        },
        {
            name: 'Pink',
            color: '#D81B60',
            textColor: '#000000',
            gradient: 'from-[#FCE4EC] to-[#D81B60]',
            cssGradient: 'linear-gradient(to right, #FCE4EC, #D81B60)'
        },
        {
            name: 'Yellow',
            color: '#E67E22',
            textColor: '#000000',
            gradient: 'from-[#FEF5E7] to-[#E67E22]',
            cssGradient: 'linear-gradient(to right, #FEF5E7, #E67E22)'
        },
        */

        //// Gray Theme and text black (Gradient-colors black)////
        {
            name: 'Gray',
            color: '#7F8C8D',
            textColor: '#000000',
            gradient: 'from-[#F2F3F4] to-[#7F8C8D]',
            cssGradient: 'linear-gradient(to right, #F2F3F4, #7F8C8D)'
        },

        /*
        {
            name: 'Black',
            color: '#2c3e50',
            textColor: '#FFFFFF',
            gradient: 'from-[#1a1c23]',
            cssGradient: '#1a1c23'
        },
        */
    ];

    const [currentTheme, setCurrentTheme] = useState(() => {
        try {
            if (savedTheme) {
                const parsed = JSON.parse(savedTheme);
                return themes.find(t => t.name === parsed.name) || parsed;
            }
            return themes[0];
        } catch (error) {
            console.error("Error parsing saved theme:", error);
            // If parsing fails, remove the invalid data and return default
            localStorage.removeItem('app-theme');
            return themes[0];
        }
    });

    const changeTheme = (themeName) => {
        const selectedTheme = themes.find(t => t.name === themeName);
        if (selectedTheme) {
            setCurrentTheme(selectedTheme);
            localStorage.setItem('app-theme', JSON.stringify(selectedTheme));
        }
    };

    return (
        <ThemeContext.Provider value={{ currentTheme, changeTheme, themes }}>
            {children}
        </ThemeContext.Provider>
    );
};
